import { render, staticRenderFns } from "./ModTerminaContrato.vue?vue&type=template&id=734c1960"
import script from "./ModTerminaContrato.vue?vue&type=script&lang=js"
export * from "./ModTerminaContrato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports